import React, { useState } from 'react';
import BidModalSC from './bid-modal.styled';
import { HeadingTwo } from '../../../typography';
import InlineLoading from '../../../ui/inline-loading';
import { FormattedMessage, injectIntl } from 'react-intl';
import dlt from '../../../../utils/default-lang';
import Button from '../../../ui/button';
import numeral from 'numeral';
import InputGroup from '../../../ui/input';

const BidModal = ({ offerDetail, onSubmit, intl }) => {
  const [bidAmount, setBidAmount] = useState('');

  const onBidAmountChange = (e) => {
    const re = /^[\d+\s?]+,?(\d+)?$/;
    if (e.target.value === '' || re.test(e.target.value)) {
      setBidAmount(e.target.value);
    }
  };

  if (offerDetail === null || Object.keys(offerDetail).length < 1) {
    return (
      <BidModalSC>
        <div className="modal-loading-wrap">
          <InlineLoading />
        </div>
      </BidModalSC>
    );
  }
  return (
    <BidModalSC>
      <div className="top-text-wrap">
        <HeadingTwo className="bold">
          <FormattedMessage
            id="investor_secondary_market_bid_modal_headline"
            defaultMessage={dlt['investor_secondary_market_bid_modal_headline']}
          />
        </HeadingTwo>
      </div>

      <div className="bid-wrap">
        <InputGroup
          value={bidAmount}
          placeholder={`${numeral(Number(offerDetail.amount_for_sale)).format('0,00.00')} €`}
          label={intl.formatMessage({
            id: `investor_secondary_market_bid_modal_input_label`,
          })}
          onChange={(e) => onBidAmountChange(e)}
        />
      </div>

      <div className="submit-wrap">
        <Button
          type="PRIMARY"
          size="BIG"
          onClick={() => onSubmit(offerDetail.offer_id, offerDetail.bidding_id, bidAmount)}
          disabled={
            bidAmount === '' ||
            bidAmount === ',' ||
            bidAmount === null ||
            parseFloat(bidAmount.replace(',', '.')) === 0
          }
        >
          <FormattedMessage id="global_bid" defaultMessage={dlt['global_bid']} />
        </Button>
      </div>
    </BidModalSC>
  );
};

export default injectIntl(BidModal);
